import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import FeaturedCategories from '@/components/feature/FeaturedCategories';
import AllCategories from '@/components/feature/AllCategories';
import AboutSection from '@/components/feature/AboutSection';
import CtaSection from '@/components/feature/CtaSection';
import BlogSection from '@/components/feature/BlogSection';
import Footer from '@/components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.my';

const homeSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'YOYBUY.my',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
    description: 'YOYBUY Spreadsheet — умная система закупок из Китая через электронные таблицы. Управляйте заказами быстро, прозрачно и без ошибок.',
    sameAs: [siteUrl],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'YOYBUY.my',
    url: siteUrl,
    description: 'YOYBUY Spreadsheet — умная система закупок из Китая через электронные таблицы. Управляйте заказами быстро, прозрачно и без ошибок.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(homeSchemas);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <FeaturedCategories />
      <AllCategories />
      <AboutSection />
      <CtaSection />
      <BlogSection />
      <Footer />
    </main>
  );
}